<div class="cadre-role-container py-3 px-4 " >
   <div class="cadre-role-header" style="display: flex; justify-content: space-between;">
  <h1>{{ data.title }}</h1>
   <i class="fa-solid fa-xmark" (click)="onCancel()"></i>
</div>
<div>
  <mat-dialog-content class="dialog-message" style="padding-left: 0px;">
    <p >{{ data.message }}</p>
  </mat-dialog-content>

 <mat-dialog-actions class="dialog-actions" style="padding-left: 0px;">
  <button mat-button class="confirm-btn"  style=" background-color: #071F42 !important;
  color: #ffffff;
  padding: 12px 8px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #071F42;
  width: 162px;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;" (click)="onConfirm()">Yes</button>
  <button mat-button class="cancel-btn" style=" background-color: #ffffff !important;
  color: #71747B;
  padding: 12px 8px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #071F42;
  width: 162px;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;" (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
</div>

</div>
